import { motion, type Variants } from "motion/react";
import type { JSX } from "react";

import { cn } from "@repo/cn";

interface LoadingDotsProps {
  /**
   * Classe de cor aplicada a cada ponto. Default: `bg-primary-500`.
   * Sobre o fundo amarelo do splash (`bg-primary-400`) o default some — nesse
   * caso use `bg-secondary-400` (azul do logo).
   */
  colorClassName?: string;
}

export const LoadingDots = ({
  colorClassName = "bg-primary-500",
}: LoadingDotsProps): JSX.Element => {
  const dotVariants: Variants = {
    initial: { y: 0 },
    animate: (i: number) => ({
      y: [0, -10, 0],
      transition: {
        duration: 0.3,
        repeat: Infinity,
        repeatDelay: 0.8,
        ease: [0.25, 0.46, 0.45, 0.94], // easeOutQuad para um pulo mais natural
        delay: i * 0.13, // Delay sequencial para cada ponto
      },
    }),
  };

  return (
    <div className="flex items-center justify-center space-x-2 p-4">
      {[0, 1, 2].map((index) => (
        <motion.div
          key={index}
          className={cn("h-2 w-2 rounded-full", colorClassName)}
          variants={dotVariants}
          initial="initial"
          animate="animate"
          custom={index}
        />
      ))}
    </div>
  );
};
